import { Input } from '@shared/UI';
import { withField } from '../withField';

export const InputField = withField(Input);
